<!--class="container-narrow"-->
<div>
  <nav-primary-cmp typerUser="trailer"></nav-primary-cmp>
  <toolbar-trailer #toolbarTrailer></toolbar-trailer>
  <div class="_router_top">
    <router-outlet></router-outlet>
  </div>
</div>
